class CustomAttendingSchedule extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[role="tabpanel"]')];

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activateTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
    });

    if (window.Shopify?.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const panel = event.target.closest('[role="tabpanel"]');
        if (!panel) return;
        const tab = this.querySelector(`[aria-controls="${panel.id}"]`);
        if (tab) this.activateTab(tab);
      });
    }
  }

  activateTab(activeTab, moveFocus = false) {
    this.tabs.forEach((tab) => {
      const selected = tab === activeTab;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activeTab.getAttribute('aria-controls');
    });

    if (moveFocus) activeTab.focus();
  }

  handleKeydown(event, index) {
    let nextIndex;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === undefined) return;
    event.preventDefault();
    this.activateTab(this.tabs[nextIndex], true);
  }
}

if (!customElements.get('custom-attending-schedule')) {
  customElements.define('custom-attending-schedule', CustomAttendingSchedule);
}
